// extracted by mini-css-extract-plugin
export default {"footerSectionContainer":"footerSection_footerSectionContainer__kPY30","linksContainer":"footerSection_linksContainer__1MYD5"};